import cn from 'classnames'

import SelectableItem from 'components/SelectableItemsList/SelectableItem'
import TextBox from 'components/TextBox'

const ModifierLabel = ({
  item,
  handleChangeCheckbox,
  handleMinMaxChange,
  selectedItemsUuids,
  modifierMinMax,
}) => {
  const checked = selectedItemsUuids.includes(item?.uuid)

  const handleChange = (itemUuid) => {
    if (checked) {
      handleChangeCheckbox(
        selectedItemsUuids?.filter(
          (selectedUuid) => selectedUuid !== itemUuid
        )
      )
    } else {
      handleChangeCheckbox([...selectedItemsUuids, itemUuid])
    }
  }
  return (
    <div
      className={cn('selectable-items__label-container', {
        '-bottom-label': checked,
      })}
    >
      <SelectableItem
        key={item?.uuid}
        handleChange={() => handleChange(item?.uuid)}
        checked={checked}
        label={item?.name}
        classNames={checked ? ['-less-padding-space'] : []}
        bottomLabel
      />
      {checked && (
        <div className="selectable-items__double-inputs padding-top-sm">
          <TextBox
            name="minimumCount"
            type="number"
            label="Minimum"
            onChange={(event) =>
              handleMinMaxChange(event, item?.uuid)
            }
            value={
              modifierMinMax?.find(
                (modifier) => modifier?.modifierUuid === item?.uuid
              )?.minimumCount
            }
          />
          <TextBox
            name="maximumCount"
            type="number"
            label="Maximum"
            onChange={(event) =>
              handleMinMaxChange(event, item?.uuid)
            }
            value={
              modifierMinMax?.find(
                (modifier) => modifier?.modifierUuid === item?.uuid
              )?.maximumCount
            }
          />
        </div>
      )}
    </div>
  )
}

export default ModifierLabel
